// extracted by mini-css-extract-plugin
export var editInput = "_h4-0";
export var editInputCompact = "_h4-2";
export var editInputLarge = "_h4-1";
export var editInputSmall = "_h4-3";